import {
  Button,
  Checkbox,
  createStyles,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  makeStyles,
  Paper,
  Theme,
  Typography,
} from '@material-ui/core';
import React, { FC, Fragment, useEffect, useState } from 'react';
import {
  GalleryImage,
  HasEvent,
  LocationDeviceAndGal,
  Devices,
} from '../../../api/infomodul/models';
import * as infomodul from '../../../api/infomodul';
import DeleteIcon from '@material-ui/icons/Delete';
import FormDialog from '../../dialogs/FormDialog';
import ConfirmDialog from '../../dialogs/ConfirmDialog';
import APIRequest from '../../helpers/APIRequest';
import * as infoModul from '../../../api/infomodul';
import PendingDialog from '../../dialogs/PendingDialog';
import CreatePage from '../../dialogs/formDialogs/CreatePage';
import ErrorDialog from '../../dialogs/ErrorDialog';
import CreateSlideshow from '../../dialogs/formDialogs/CreateSlideshow';
import { ApiResponse } from '../../../api';
import UpdateNowDialog from '../../dialogs/UpdateNowDialog';

const useStyles = makeStyles((theme: Theme) => createStyles({
  fullHeight: {
    height: '100%',
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  maxParent: {
    maxWidth: '100%',
    maxHeight: '10rem',
  },
  paper: {
    marginBottom: '1.5rem',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  iconText: {
    fontSize: '15px',
  },
  imgInfo: {
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  image: {
    textAlign: 'center',
    marginLeft: '22px',
    [theme.breakpoints.down('md')]: {
      marginLeft: '0px',
    },
  },
  iFrame: {
    border: 'none',
    display: 'block',
    margin: '0 auto',
    textAlign: 'center'
  }
}));

interface Props {
  selectedDevices: number[];
  selectedDeviceIds: number[];
  galleryData: GalleryImage[];
  deviceData: Devices[];
  eventData: HasEvent[];
  locationData: LocationDeviceAndGal;
  selectedTab: number;
  setEdit: React.Dispatch<React.SetStateAction<boolean>>;
  setDeviceBoxDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  setUpdateOnDeviceBoxChange: React.Dispatch<React.SetStateAction<boolean>>;
  setRunGetGalleryImages: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedDeviceIds: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectedDevices: React.Dispatch<React.SetStateAction<number[]>>;
}

const FrontView: FC<Props> = ({
  selectedDevices,
  selectedDeviceIds,
  galleryData,
  deviceData,
  eventData,
  locationData,
  selectedTab,
  setEdit,
  setDeviceBoxDisabled,
  setUpdateOnDeviceBoxChange,
  setRunGetGalleryImages,
  setSelectedDeviceIds,
  setSelectedDevices,

}) => {
  const classes = useStyles();
  const [selectedImage, setSelectedImage] = useState<number>();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [seletedImageId, setSeletedImageId] = useState<number>();
  const [Duration, setDuration] = useState<number | undefined>();
  const [createImageOpen, setCreateImageOpen] = useState(false);
  const [createSlideshowOpen, setCreateSlideshowOpen] = React.useState(false);
  const [runActiveSlideshows, setActiveSlideshows] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [galleryTooBigOpen, setGalleryTooBigOpen] = useState(false);
  const [invalidDurationOpen, setInvalidDurationOpen] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [apiErrorText, setApiErrorText] = useState<string>('');
  const [apiErrorTitle, setApiErrorTitle] = useState<string>('');
  const [removedImages, setRemovedImages] = useState<number[]>([]);

  const [isPending, setIsPending] = useState(false);
  const [imageFile, setImageFile] = useState<string | Blob>('');
  const [imgType, setImgType] = useState<string>('');
  const [imageDescription, setImageDescription] = useState<string>('');

  const [runSave, setRunSave] = useState(false);
  const [updateNow, setUpdateNow] = useState(false);
  const [runGetSlideshows, setRunGetSlideshows] = useState(false);
  const [runDeleteImage, setRunDeleteImage] = useState(false);
  const [runCreateOutOfOrder, setRunCreateOutOfOrder] = useState(false);
  const [selectedImagesId, setSelectedImagesId] = useState<number[] | undefined>([]);
  const [imgNames, setimgNames] = useState<string[] | undefined>([]);
  const [devicesForSlideshow, setDevicesForSlideshow] = useState<string[] | undefined>([]);
  const [getActiveSlideshows, setGetActiveSlideshows] = useState<string[]>([]);
  const [getActiveImage, setGetActiveImage] = useState<string[]>([]);
  const [alreadyActive, setAlreadyActive] = useState<string[] | undefined>([]);

  useEffect(() => {
    setSelectedDeviceIds([]);
    setSelectedDevices([]);
  }, []);

  useEffect(() => {
    setDeviceBoxDisabled(false);
    setUpdateOnDeviceBoxChange(false);
  }, [setDeviceBoxDisabled, setUpdateOnDeviceBoxChange]);


  useEffect(() => {
    SlideshowInfo();
  }, []);

  useEffect(() => {
    ImgActive();
  }, []);


  useEffect(() => {
    if (updateNow) {
      ForceUpdateDevice();
      setRunSave(false);
      setEdit(false);
      setSelectedDeviceIds([]);
    }
  }, [updateNow]);


  const ForceUpdateDevice = () => {
    infomodul.DeviceUpdateNow({
      body: {
        deviceid: selectedDeviceIds,
        masterPort: locationData.devices[0].masterPort
      },
    })
  };


  const UpdateActiveImages = async () => {
    if (selectedImage !== undefined) {
      const apiRequests = [];
      const request = {
        masterPort: locationData.devices[0].masterPort,
        imgName: galleryData[selectedImage].imgName,
        imgDescription: galleryData[selectedImage].imgDescription,
        type: galleryData[selectedImage].type,
        imgActive: galleryData[selectedImage].imgActive,
        start: findStartTime() || undefined,
        stop: findEndTime() || undefined,
      };

      // Include clientHash if selectedDeviceIds is not empty
      if (selectedDeviceIds && selectedDeviceIds.length > 0) {
        selectedDeviceIds.forEach((element) => {
          const device = deviceData.find((device) => device.deviceNumber === element);
          if (device) {
            const requestClientHash = { ...request, clientHash: device.clientHash };
            apiRequests.push(requestClientHash);
          }
        });
        //If selectedDeviceIds is empty, do not include clientHash
      } else {
        apiRequests.push(request);
      }
      //Update the image, and check if any devices has deactivated the image
      try {
        const response = await infomodul.updateActiveImg({ body: apiRequests });
        if (response.data != undefined && response.data.failedClientHash.length > 0 && response.data.failedClientHash != '') {
          const failedResponse = response.data.failedClientHash;
          let failedHashes:any;

          //If a failedClienthash is in already active, that means it fails, because this picture already has a activeslideshow -
          //with that clienthash. So it should ignore that clienthash.
          if(alreadyActive)
          {
            failedHashes = failedResponse.filter(
            (failedHash: any) => !alreadyActive.includes(failedHash)
          );
          }
          //If no failedhash is already active, all of the failedhashes from the response should be displayed.
          else {
            failedHashes = failedResponse;
          }
          
          //Show error of the devices where the image was failed to be updated.
          if (failedHashes.length > 0) {
            setApiError(true);
            setApiErrorTitle('Fejl - kunne ikke gemme ændringer');
            setApiErrorText(`Kunne ikke opdatere billedet på automat: ${failedHashes.join(', ')} - Tjek om der er et slideshow kørende på automaten, deaktiver billederne og prøv igen`);
            return null;
          }
        }
        if (response.data != undefined && response.data.removedImages.length > 0 && response.data.removedImages != '') {
          setRemovedImages(response.data.removedImages);
          let changedDevices = [...selectedDeviceIds];
          response.data.removedImages.forEach((element: any) => {
            changedDevices.push(element);
          });
          setSelectedDeviceIds(changedDevices);
        } else {
          setRemovedImages([]);
        }
        setRunSave(true);
      } catch (error) {
        setApiError(true);
        setApiErrorTitle('Fejl - kunne ikke gemme ændringer');
        setApiErrorText('Tjek om der er et slideshow kørende på automaten - deaktiver billederne og prøv igen.');
      }


    }

    return null;
  };



  //If image has an event return it (Start date and time)
  function findStartTime() {
    if (selectedImage !== undefined) {
      var res = eventData.filter((img) => {
        return img.galleryImageId === galleryData[selectedImage].id;
      });
      if (res.length > 0) {
        return res[0].start;
      } else {
        return undefined;
      }
    }
  }

  //If image has an event return it (End date and time)
  function findEndTime() {
    if (selectedImage !== undefined) {
      var res = eventData.filter((img) => {
        return img.galleryImageId === galleryData[selectedImage].id;
      });
      if (res.length > 0) {
        return res[0].stop;
      } else {
        return undefined;
      }
    }
  }

  //Sets the toggled image
  const handleToggleImages = (value: number) => () => {
    let deviceids:any = [];
    if (selectedImage !== value) {
      setSelectedImage(value);
      infoModul.getImageDevice(galleryData[value]).then((devNumbers) => {
        if (devNumbers.data != undefined) {
          setSelectedDeviceIds(devNumbers.data);
          devNumbers.data.forEach((element, index) => {
            if(devNumbers.data)
            {
              deviceids.push(devNumbers.data[index]);
            }
          });
          if (deviceids && deviceids.length > 0) {
            let clientHashes:any = [];
            deviceids.forEach((element:number) => {
              const device = deviceData.find((device) => device.deviceNumber === element);
              if (device) {
                clientHashes.push(device.clientHash);
              }
            });
            setAlreadyActive(clientHashes);
            deviceids = [];
          }
        }
      })




      // ).then((deviceData) => {
      //   console.log('test...: '+deviceData);
      // })

    } else {
      setSelectedImage(undefined);
      setSelectedDeviceIds([]);
    }
  };

  //Display the image type information in another format.
  function TypeInfo(type: string) {
    switch (type) {
      case 'udeafdrift':
        return 'Type: Ude af drift';
      case 'pauseskaerm':
        return 'Type: Pauseskærm';
      case 'reklame':
        return 'Type: Reklame';
    }
  }

  const SlideshowInfo = async () => {
    if (galleryData.length > 0) {
      for (let i = 0; i < galleryData.length; i++) {
        await infomodul.getSlideshowInfo(galleryData[i].imgName).then((response) => {
          setGetActiveSlideshows(oldArray => [...oldArray, response.data]);
        })
      }
    }
    return getActiveSlideshows;
  }

  const ImgActive = async () => {
    if (galleryData.length > 0) {
      const activeImages = [];

      for (let i = 0; i < galleryData.length; i++) {
        const response = await infomodul.getActiveInfo(galleryData[i].imgName);
        activeImages.push(response.data);
      }

      setGetActiveImage(activeImages);
    }

    return getActiveImage;
  };

  //Posts image to database when created by the user
  const CreateImage = () => {
    var formData = new FormData();
    formData.append('file', imageFile);
    formData.append('description', imageDescription);
    formData.append('type', imgType);

    return (
      <APIRequest<any>
        run={runCreateOutOfOrder}
        setRun={setRunCreateOutOfOrder}
        pending={isPending}
        setIsPending={setIsPending}
        req={() =>
          infoModul.postCreateImage({
            galleryId: locationData.galleries[selectedTab].id,
            form: formData,
          })
        }
        setData={() => {
          setRunGetGalleryImages(true);
          setImageDescription('');
          setImgType('');
          setImageFile('');
        }}
        setShowError={() => {
          setApiError(true);

        }}
        storeError={(error) => {
          setApiErrorTitle('Fejl - kunne ikke tilføje billede')
          setApiErrorText('Tjek om det valge billede opfylder krav, om størrelse og filformat - og prøv igen.')
        }}
      />
    );
  };

  //Post slideshow to database
  const PostSlideshow = () => {
    return (
      <Fragment>
        {selectedImagesId && (
          <APIRequest<any>
            run={runActiveSlideshows}
            setRun={setActiveSlideshows}
            pending={isPending}
            setIsPending={setIsPending}
            req={() =>
              infomodul.createSlideshow({
                body: {
                  GalleryID: locationData.galleries[selectedTab].id,
                  GalleryImageID: selectedImagesId,
                  clientHash: devicesForSlideshow,
                  masterPort: locationData.devices[0].masterPort,
                  duration: Duration,
                },
              })
            }
            setData={() => {
              setActiveSlideshows(false);
              setDevicesForSlideshow([]);
              // setSelectedDeviceIds([]);
              setSelectedImage(undefined);
              setimgNames([]);
              setRunSave(true);
              // setEdit(false);
              setRunGetSlideshows(true);
            }}
            setShowError={() => {
              setApiError(true);
              setSelectedDeviceIds([]);

            }}
            storeError={(error) => {
              setApiErrorTitle('Fejl - kunne ikke lave slideshow')
              if (error == 400) {
                setApiErrorText('Et slideshow skal bestå af minimum 2 billeder.\nSørg for at vælge minimum 2 billeder af samme type, og prøv igen')
              }
              else {
                setApiErrorText('Tjek om der allerede findes et slideshow med en anden billede type - deaktiver billederne, og prøv igen.')
              }
            }}
          />
        )}
      </Fragment>
    );
  };

  //Removes image from gallery and database
  const DeleteImage = () => {
    return (
      <Fragment>
        {seletedImageId && (
          <APIRequest<any>
            run={runDeleteImage}
            setRun={setRunDeleteImage}
            pending={isPending}
            setIsPending={setIsPending}
            req={() =>
              infoModul.deleteImage({
                imageId: seletedImageId,
                imageName: findImgName(seletedImageId),
              })
            }
            setData={() => {
              setRunGetGalleryImages(true);
            }}
          />
        )}
      </Fragment>
    );
  };

  //Find image name for deleting image - also to remove events or remove it from the deviceimages table
  function findImgName(id: number) {
    var res = galleryData.filter((data) => {
      return data.id === id;
    });
    return res[0].imgName;
  }

  return (
    <Grid container spacing={2}>
      <CreateImage />
      <PostSlideshow />
      <DeleteImage />
      <Grid item xs={12}>
        <Typography component="h2" variant="h5">
          Galleri
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                setDeviceBoxDisabled(true);
                setUpdateOnDeviceBoxChange(true);
                setEdit(false);
              }}
            >
              Tilbage
            </Button>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => setCreateImageOpen(true)}
            >
              Tilføj billede
            </Button>
          </Grid>
          <Grid item xs={12} lg={3} sm={4}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                setCreateSlideshowOpen(true)
              }}
            >
              Tilføj slideshow
            </Button>
          </Grid>
          <Grid item xs={12} lg={3} sm={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                if (selectedImage !== undefined) {
                  // setRunSave(true);
                  UpdateActiveImages();
                }
                else {
                  setEdit(false);
                }
                // UpdateActiveImages();
                // updateActiveImages();
                // setEdit(false);
              }}
            >
              Gem
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid style={{ overflowY: 'scroll', maxHeight: "71vh", overflowX: 'hidden', width: '100%' }}>
        <Grid item xs={12}>
          <List>
            {galleryData.length > 0 ? (
              <Fragment>
                {galleryData.map((value, i) => {
                  const labelId = `checkbox-list-label-${value}`;

                  return (
                    <Paper key={i} className={classes.paper}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                          <ListItem
                            role={undefined}
                            dense
                            button
                            onClick={handleToggleImages(i)}
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={2} lg={1}>
                                <ListItemIcon>
                                  <Checkbox
                                    edge="start"
                                    color="primary"
                                    checked={i === selectedImage}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': labelId }}
                                  />
                                </ListItemIcon>
                              </Grid>
                              <Grid item xs={12} sm={12} lg={3}>
                                <Typography component="div">
                                  <div className={classes.imgInfo}>
                                    Tilgængelig på: {getActiveImage[i]?.length || 0} automater
                                  </div>
                                  <div className={classes.imgInfo}>
                                    <embed
                                      type="text/html"
                                      src={`${infomodul.baseUrl()}/listofactive/${value.imgName
                                        }`}
                                    ></embed>
                                  </div>
                                </Typography>
                                {getActiveSlideshows[i] != "" && (
                                  <Typography component="div" style={{ marginTop: '0px' }}>
                                    <div className={classes.imgInfo}>
                                      Slideshow aktiv på:
                                    </div>
                                    <div className={classes.imgInfo}>
                                      <embed type="text/html"
                                        src={`${infomodul.baseUrl()}/listofslideshow/${value.imgName}`}
                                      ></embed>
                                    </div>
                                  </Typography>
                                )}

                                <Typography component="h6" variant="h6">
                                  <div className={classes.imgInfo}>
                                    {value.imgDescription}
                                  </div>
                                </Typography>
                                <Typography component="p">
                                  <div className={classes.imgInfo}>
                                    {TypeInfo(value.type)}
                                  </div>
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={12} lg={7}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    xs={12}
                                    // style={{ textAlign: 'center' }}
                                    className={classes.image}
                                  >
                                    <img
                                      src={`${infomodul.baseUrl()}/image/${value.imgName
                                        }`}
                                      className={classes.maxParent}
                                      alt={value.imgName}
                                      width={'270rem'}
                                    ></img>
                                  </Grid>
                                  <Grid item xs={6} sm={12} style={{ position: 'absolute', top: 0, right: 0 }}>
                                    <IconButton
                                      aria-label="delete"
                                      onClick={() => {
                                        setSeletedImageId(value.id);
                                        setDeleteOpen(true);
                                      }}
                                    >
                                      <DeleteIcon />
                                      <div className={classes.iconText}>
                                        Slet billedet
                                      </div>
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </ListItem>
                        </Grid>
                      </Grid>
                    </Paper>
                  );
                })}
              </Fragment>
            ) : (
              <div>Ingen data valgt</div>
            )}
          </List>
        </Grid>
      </Grid>

      <FormDialog
        title={'Tilføj billede'}
        open={createImageOpen}
        onCloseCancel={() => {
          setCreateImageOpen(false);
          setImageDescription('');
          setImgType('');
          setImageFile('');
        }}
        onCloseSubmit={() => {
          if (
            imageFile !== '' &&
            imgType !== '' &&
            imageDescription !== '' &&
            galleryData.length <= 10
          ) {
            setRunCreateOutOfOrder(true);
            setCreateImageOpen(false);
          } else {
            if (galleryData.length >= 10) {
              setGalleryTooBigOpen(true);
            } else {
              setErrorOpen(true);
            }
          }
        }}
      >
        <CreatePage
          setImageFile={setImageFile}
          setImageDescription={setImageDescription}
          setImgType={setImgType}

        />
      </FormDialog>

      <FormDialog
        title={'Slideshow'}
        open={createSlideshowOpen}
        onCloseCancel={() => {
          setCreateSlideshowOpen(false);
          setSelectedDeviceIds([]);
          setimgNames([]);
          setSelectedImage(undefined);
          setSelectedImagesId([]);
          setDuration(undefined);
        }}
        onCloseSubmit={() => {
          if (imgNames?.length !== 0 && selectedImagesId?.length !== 0 && devicesForSlideshow?.length !== 0 && Duration !== undefined && Duration >= 10 && Duration <= 60) {
            setActiveSlideshows(true);
            setCreateSlideshowOpen(false);
          } else {
            if (Duration && Duration < 10 || Duration && Duration > 60) {
              setInvalidDurationOpen(true);
            } else {
              setErrorOpen(true);
            }
          }
        }}
      >
        <CreateSlideshow
          deviceData={deviceData}
          galleryData={galleryData}
          Duration={setDuration}
          selectedImagesId={setSelectedImagesId}
          imgNames={setimgNames}
          devicesForSlideshow={setDevicesForSlideshow}
          deviceNumbersForSlideshow={setSelectedDeviceIds}
        />
      </FormDialog>

      <ErrorDialog
        open={errorOpen}
        onClose={function (): void {
          setErrorOpen(false);
        }}
        title={'Forkert input'}
        text={'Husk at udfylde alle felter'}
      />

      <ErrorDialog
        open={galleryTooBigOpen}
        onClose={function (): void {
          setGalleryTooBigOpen(false);
        }}
        title={'Grænse nået'}
        text={'Der er for mange billeder i galleriet'}
      />

      <ErrorDialog
        open={invalidDurationOpen}
        onClose={function (): void {
          setInvalidDurationOpen(false);
        }}
        title={'Ugyldig varighed'}
        text={'Varigheden af billedfremvisning skal være mellem 10 og 60 sekunder'}
      />

      <ErrorDialog
        open={invalidDurationOpen}
        onClose={function (): void {
          setInvalidDurationOpen(false);
        }}
        title={'Ugyldig varighed'}
        text={'Varigheden af billedfremvisning skal være mellem 10 og 60 sekunder'}
      />

      <ErrorDialog
        open={apiError}
        onClose={function (): void {
          setApiError(false);
        }}
        title={apiErrorTitle}
        text={apiErrorText}
      />

      <ConfirmDialog
        title={'Sikker på at du vil slette billedet?'}
        text={'Slet'}
        open={deleteOpen}
        onConfirm={() => {
          setRunDeleteImage(true);
          setDeleteOpen(false);
        }}
        onClose={() => setDeleteOpen(false)}
      />

      <UpdateNowDialog
        title={'Dine ændringer gemmes, vælg ønskede metode'}
        updateNow={'Opdater nu'}
        updateLater={'Opdater ved midnat'}
        open={runSave}
        onUpdateNow={async () => {
          // await UpdateActiveImages();
          setUpdateNow(true);

        }}
        onUpdateLater={async () => {
          // UpdateActiveImages();
          setRunSave(false);
          setEdit(false)
          setSelectedDeviceIds([]);
        }}
        // onClose={() => setRunSave(false)}
      />
      <PendingDialog open={isPending} title={'Loading'} />
    </Grid>
  );
};

export default FrontView;
